{
  "loading": "Učitavam...",
  "placeholder": "Izaberite opciju"
}
